import Swiper from "swiper";
import { Grid } from 'swiper/modules';
import { $Q } from '../utils/query-selector';
import 'swiper/css/bundle';

const initProductsSwiper = () => {
  const container = $Q('.jolly-products-blocks__mobile');

  if (!container) return;

  new Swiper(container, {
    modules: [Grid],
    slidesPerView: 1.3,
    breakpoints: {
      320: {
        slidesPerView: 1.3
      },
      768: {
        slidesPerView: 2.3
      }
    },
    spaceBetween: 16,
    grid: {
      rows: 1,
    }
  });
};

export default initProductsSwiper;
